import { AnyType } from "@/types";
import moment, { Moment } from "moment";
import isElectron from 'is-electron';
import { getBrowserCompatibility } from "./browser-compatibility";

export const omit: (a: AnyType, b: string | Array<string>) => AnyType = (
  a,
  b
) => {
  b = Array.isArray(b) ? b : [b];
  const ret: AnyType = {};
  Object.keys(a).forEach((ak) => {
    if (!b.includes(ak)) {
      ret[ak] = a[ak];
    }
  });
  return ret;
};

export const pick: (a: AnyType, b: string | Array<string>) => AnyType = (
  a,
  b
) => {
  b = Array.isArray(b) ? b : [b];
  const ret: AnyType = {};
  Object.keys(a).forEach((ak) => {
    if (b.includes(ak)) {
      ret[ak] = a[ak];
    }
  });
  return ret;
};

export const storage = {
  save: (k: string, v: any) => {
    if (typeof v === "string") {
      window.localStorage.setItem(k, v);
      return;
    }
    try {
      v = JSON.stringify(v);
    } catch (ex) {
      //
    }
    window.localStorage.setItem(k, v);
  },
  get: (k: string) => {
    let av = window.localStorage.getItem(k) || "{}";
    try {
      av = JSON.parse(av);
    } catch (ex) {
      //
    }
    return av as any;
  },
  remove: (k: string) => {
    window.localStorage.removeItem(k);
  },
};

export const TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
const __format = (date: Moment) => date.format(TIME_FORMAT);

export const time = {
  format: (date: Moment) => date.format("YYYY-MM-DD HH:mm:ss"),
  formatNow: () => __format(moment()),
};
export const isMobile = () => {
  return !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/);
};
export const isIpad = () => {
  return navigator.userAgent.indexOf('iPad') > -1;
};
export const isWeixin = () => {
  const ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
  return ua.indexOf("micromessenger") != -1;
};
export const isChrome = () => {
  return navigator.userAgent.indexOf("Chrome") !== -1;
};

export const inElectron=()=>{
  return isElectron();
}

export const notChromeMessage = () => {
  return getBrowserCompatibility().message;
};

export function isLocalStorageSupported(): boolean {
  try {
      const testKey = 'test';
      localStorage.setItem(testKey, 'testValue');
      localStorage.removeItem(testKey);
      return true;
  } catch (e) {
      return false;
  }
}

export function checkLocalStorageKey(key: string): boolean {
  if (!isLocalStorageSupported()) {
      console.log('localStorage is not supported.');
      return false;
  }

  const value = localStorage.getItem(key);
  return value !== null;
}
